const loadGoogleMapsApi = require('load-google-maps-api');

class Map {
  
    static loadGoogleMapsApi() {
      return loadGoogleMapsApi({ key: "AIzaSyD5Zo4FCitnTgCGBvTBvzgj5lK87s07X1A" });
    }
    static createMap(googleMaps, mapElement) {
        var mapData    = { pos: { lat: 38.146294, lng: 140.535526 }, zoom: 16};
        //マーカー情報(情報ウインドウ含む)
        var markerData = [
            { pos: { lat: 38.146294, lng: 140.535526 }, title: "青根温泉", icon:{url: "https://japponoyu.jp/wp-content/themes/japponoyu/img/ico_map.png", scaledSize: new google.maps.Size(63, 63)}, infoWindowOpen: false, infoWindowContent: "<p>〒989-0908 宮城県柴田郡川崎町青根温泉９−１</p><p>TEL: 0224-87-2188</p>"},
        ];
        //地図の設定と作成
        var map = new google.maps.Map(document.getElementById('map'), {
            center: mapData.pos,
            zoom:   mapData.zoom,
            mapTypeControl: false,
            panControl: false,
            scaleControl: false,
            streetViewControl: false,
            styles: [
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#d6e9ca"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        }
                    ]
                }
            ]
        });
        for( var i=0; i < markerData.length; i++ )
        {
            //即時関数
            (function(){
                //マーカーの設定と作成
                var marker = new google.maps.Marker({
                    position: markerData[i].pos,
                    title:    markerData[i].title,
                    icon:     markerData[i].icon,
                    map: map
                });
                if( markerData[i].infoWindowContent )
                {
                    //情報ウインドウの設定と作成
                    var infoWindow = new google.maps.InfoWindow({
                        content: markerData[i].infoWindowContent
                    });
                    //情報ウインドウのオープンをマーカーのクリックイベントに登録
                    marker.addListener('click', function(){
                        infoWindow.open(map, marker);
                    });
                    //情報ウインドウのオープン
                    if( markerData[i].infoWindowOpen )
                    {
                        infoWindow.open(map, marker);
                    }
                }
            }());
        }
    }
  }
export { Map };
